module.exports = __webpack_public_path__ + "img/mAppleID.a3ed31a.svg";